export const READ_MORE_TEXT_LIMIT = 50;

export const OPERATION_TYPE = {
  ADD: 'add',
  INC: 'inc',
  DEC: 'dec',
  SAVE: 'save',
};
